// Job photos for the public gallery. Files live in public/gallery/.
// Add a photo: put NN-name.webp (1400px long side) and NN-name-sm.webp (640px) in public/gallery,
// then add a line below. Set `city` when you know the town the job was in.
export const SITE = "https://skedaddlejunk.com";
export const AREA = "Charleston, SC tri-county area";
export const TOWNS = ["Summerville", "Goose Creek", "Moncks Corner", "North Charleston", "Ladson", "West Ashley", "Charleston", "Johns Island", "Mount Pleasant", "James Island"];

const L = { w: 1400, h: 1050, sw: 640, sh: 480 }; // landscape
const T = { w: 1050, h: 1400, sw: 480, sh: 640 }; // portrait

const RAW = [
  ["01-garage-cleanout-truck-trailer", "Garage cleanout, truck and trailer full", "Garage cleanout", T, "Summerville"],
  ["02-ladder-cabinets-trailer", "Ladder, metal cabinets and more, loaded and gone", "Junk hauling", T, "Goose Creek"],
  ["03-mattress-rugs-boxes", "Mattress, rugs and moving boxes in one trip", "Mattress disposal", T, "Mount Pleasant"],
  ["04-workshop-shed-cleared", "Workshop shed cleared out", "Shed cleanout", L, "Moncks Corner"],
  ["05-full-dumpster-cleanout", "Whole house cleanout", "Estate cleanout", T, "Johns Island"],
  ["06-oven-crate-toys", "Wall oven, dog crate and outgrown toys", "Appliance removal", T, "Ladson"],
  ["07-storage-shed-emptied", "Storage shed emptied and swept", "Shed cleanout", L, "North Charleston"],
  ["08-household-junk-loaded", "Household junk loaded up", "Junk removal", T, "James Island"],
  ["09-cabinets-scrap-metal", "Old cabinets and scrap metal hauled off", "Scrap metal removal", T, "West Ashley"],
  ["10-workout-gear-tanks", "Workout gear and metal tanks out of the yard", "Yard junk removal", T, "Summerville"],
  ["11-garage-shelving-appliances", "Garage shelving and old appliances gone", "Appliance removal", T, "Goose Creek"],
  ["12-old-fridge-shed-chemicals", "Old fridge packed with shed chemicals", "Refrigerator removal", T, "Johns Island"],
  ["13-rusty-trailer-frame", "Rusty trailer frame removal", "Heavy material hauling", T, "Charleston"],
  ["14-curbside-boxes", "Curbside boxes cleared", "Curbside junk pickup", T, "North Charleston"],
];

export const GALLERY = RAW.map(([n, caption, service, s, city]) => {
  const where = city ? `${city}, SC` : AREA;
  return {
    name: n, caption, service, city,
    src: `/gallery/${n}.webp`, sm: `/gallery/${n}-sm.webp`,
    w: s.w, h: s.h, sw: s.sw, sh: s.sh,
    where,
    alt: `${caption}. ${service} by Skedaddle Junk Removal in the ${city ? `${city}, SC area` : AREA}.`,
    title: `${service} in ${where}`,
  };
});

export const HOME_GALLERY = GALLERY.slice(0, 6);

// schema.org markup for a set of gallery photos
export const galleryLd = (items, pagePath = "/gallery") => ({
  "@context": "https://schema.org",
  "@type": "ImageGallery",
  "@id": `${SITE}${pagePath}#gallery`,
  name: "Skedaddle Junk Removal job photos",
  description: `Real junk removal jobs across the ${AREA}: ${TOWNS.join(", ")} and more.`,
  url: `${SITE}${pagePath}`,
  author: { "@id": `${SITE}/#business` },
  spatialCoverage: TOWNS.map((t) => ({ "@type": "Place", name: `${t}, SC` })),
  associatedMedia: items.map((g) => ({
    "@type": "ImageObject",
    contentUrl: `${SITE}${g.src}`,
    thumbnailUrl: `${SITE}${g.sm}`,
    name: g.title,
    caption: g.caption,
    description: g.alt,
    encodingFormat: "image/webp",
    width: g.w, height: g.h,
    keywords: [g.service, "junk removal", `junk removal ${g.city || "Charleston SC"}`, "Skedaddle Junk Removal"].join(", "),
    contentLocation: { "@type": "Place", name: g.where, address: { "@type": "PostalAddress", ...(g.city ? { addressLocality: g.city } : {}), addressRegion: "SC", addressCountry: "US" } },
    creator: { "@id": `${SITE}/#business` },
    copyrightHolder: { "@id": `${SITE}/#business` },
    creditText: "Skedaddle Junk Removal",
  })),
});
